// Application class
class RudderApp {
  constructor() {
    this.name = 'RudderLabs JavaScript SDK';
    this.namespace = 'com.rudderlabs.javascript';
    this.version = '__PACKAGE_VERSION__';
  }
}
export default RudderApp;
